module.exports = __webpack_public_path__ + "static/img/searchWhite.e7376c16.png";